module.exports = __webpack_public_path__ + "static/img/headerImg.1f569ed1.png";